import { db } from 'boot/firebase';
import { collection, collectionGroup, getDocs, limit, query, where } from 'firebase/firestore';
import ProgramsDB from 'src/fb/programs-db';

import GenericDB from './generic-db';

export default class ProgramTargetsDB extends GenericDB {
  constructor(programId = null) {
    super('', 'programs.programTargets');
    this.setProgramId(programId);
  }

  setProgramId(programId) {
    this.programId = programId;
  }

  getCollectionRef() {
    return collection(db, 'programs', this.programId, 'programTargets');
  }

  /**
   * Load programTargets that use a specific element
   *
   * @param {string} key - field name in the programTarget document
   * @param {string} elementId
   * @param {string} clinic
   * @returns {Promise<array> List of programs}
   */
  static async readByElementWithProgram(key, elementId, maxElements = null) {
    let queryBuilder = collectionGroup(db, 'programTargets');
    queryBuilder = query(queryBuilder, where(key, '==', elementId));

    if (maxElements) {
      queryBuilder = query(queryBuilder, limit(maxElements));
    }

    const res = await getDocs(queryBuilder);

    if (res.empty) {
      return [];
    }

    const programsDb = new ProgramsDB();
    const programTargets = await Promise.all(
      res.docs.map(async (doc) => {
        const programId = doc.ref.parent.parent.id;
        const program = await programsDb.read(programId);

        if (!program || program.isDeleted) {
          return null;
        }

        return {
          ...doc.data(),
          id: doc.id,
          program,
        };
      }),
    );

    return programTargets.filter((programTarget) => programTarget !== null);
  } // readByElement()
}
